import { FC } from 'react';

import { Box, Divider, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { Element } from 'react-scroll';

import BundleFixedGlanceSection from './bundleFixedGlanceSection';

import Container from '@components/store/container';
import ProductDescription from '@components/store/product/productDescription';
import { BundleEntity } from '@redux/bundle/type/BundleDetailType';

type BundleDescriptionProps = {
  scrollElementName: string;
  bundleDetailSeo: BundleEntity;
};

const BundleDescription: FC<BundleDescriptionProps> = ({ scrollElementName, bundleDetailSeo }) => {
  const { t } = useTranslation('store_course');

  const productDescription = bundleDetailSeo?.description || `${t('bundle_detail.text')} ${bundleDetailSeo.name}`;

  return (
    <Element name={scrollElementName}>
      <Container
        containerSx={{
          display: 'grid',
          gridTemplateColumns: { lg: '60% auto' },
          gridTemplateRows: { lg: '40px 1fr' },
          gap: 2,
          pt: { xs: 3, md: 5, lg: 4.5 },
          pb: 0,
          px: { xs: 3, lg: 0 },
        }}
      >
        <Box>
          <Typography variant="h4">{t('bundle_detail.bundle_description.title')}</Typography>
          <Divider sx={{ marginTop: 2 }} />
        </Box>

        <Box gridColumn={{ lg: '2/3' }} gridRow={{ lg: '1/3' }}>
          <BundleFixedGlanceSection />
        </Box>

        <Box display="flex" flexDirection="column" gap={{ xs: 2, md: 3 }}>
          <ProductDescription description={productDescription} />
        </Box>
      </Container>
    </Element>
  );
};

export default BundleDescription;
